// extracted by mini-css-extract-plugin
export default {"cls1":"FilterContainer-Chips_cls1__AHgdo","cls2":"FilterContainer-Chips_cls2__H-2Xh FilterContainer-Chips_cls1__AHgdo"};